import React from "react";
import { Route, Redirect } from "react-router-dom";

interface Props {
    path: string;
    component: any;
    authenticated: boolean;
    verified: boolean;
    exact?: boolean;
}

const Authenticated = ({ path, component, authenticated, verified, exact }: Props) => (
    authenticated ?
        verified ? <Route path={path} component={component} exact={exact} />
            : <Redirect to="/email/verify" />
        : <Redirect to="/login" />
)

export default Authenticated;
